/*
 * Copyright (c) 2021 EGT Digital - All rights reserved.
 *
 * File: SettingsTab.tsx
 *
 * Written by Yuliyan Milenkov <yuliyan.milenkov@egt-digital.com> on  06.02.23 5:39 pm.
 * Last modified: 06.02.23 5:39 pm.
 *
 * More information at: https://egt-digital.com/
 */
import React, { useEffect, useState } from 'react';
import { useTranslator } from '../../contexts/TranslatorContext';
import store from '../../eventStore';

const SettingsTab = () => {
    const translate = useTranslator();
    const [muted, setMuted] = useState<boolean>(store.ON_SOUND_MUTED.value);

    useEffect(() => {
        const subscribtion = store.ON_SOUND_MUTED.subscribe(value => setMuted(value));

        return () => subscribtion.unsubscribe();
    }, []);

    const onClickToggleSounds = () => {
        store.COMMUNICATION_CHANNEL.next({
            event: 'mute',
            value: !muted,
        });
    };

    return (
        <div className="egt_lobby_settings_options">
            <div className="egt_lobby_settings_options_text">
                <div className="label">{translate('Sound')}</div>
                <div className="description">{translate('Sound_Description')}</div>
            </div>
            <div
                className={`egt_lobby_settings_options_checkbox ${!muted ? 'selected' : ''}`}
                onClick={onClickToggleSounds}
            >
                <div className="dot"></div>
            </div>
        </div>
    );
};

export default SettingsTab;
